import api from '@utils/api';
import Button from '@ui/button/Button';
import ModalDialogWithImage from '@ui/modal/ModalDialogWithImage';
import analytics from '@utils/analytics';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import LoginOrRegisterColumn from './LoginOrRegisterColumn';
const LoginModal = (props) => {
    const { t } = useTranslation();
    const defaultData = {
        image: window.loginImageFolder + (props.incontext ? 'bg-' + props.incontext + '.jpg' : props.fromMbm ? 'bg-mbmpurchase.jpg' : 'bg-login.jpg'),
        imageAlt: 'login image',
        title: props.incontext ? t('modal.loginregister.title' + props.incontext) : props.fromMbm ? t('modal.loginregister.titlembmpurchase') : t('modal.loginregister.title'),
        subtitle: props.incontext
            ? t('modal.loginregister.subtitle' + props.incontext)
            : props.fromMbm
                ? t('modal.loginregister.subtitlembmpurchase')
                : t('modal.loginregister.subtitle'),
        cta: t('login.loginregister'),
        paragraph: '',
    };
    const [open, setOpen] = useState(false);
    const [openRegister, setOpenRegister] = useState(false);
    const [forceReload, setForceReload] = useState(false);
    const [modalData, setModalData] = useState();
    // [ UPDATE EXTERNAL => SYNC INTERNAL ]
    useEffect(() => {
        if ((props === null || props === void 0 ? void 0 : props.modalStatus) != undefined && (props === null || props === void 0 ? void 0 : props.modalStatus) != open) {
            setOpen(props === null || props === void 0 ? void 0 : props.modalStatus);
        }
    }, [props === null || props === void 0 ? void 0 : props.modalStatus]);
    // [ UPDATE INTERNAL => SYNC EXTERNAL ]
    useEffect(() => {
        if ((props === null || props === void 0 ? void 0 : props.updateStatus) != undefined && (props === null || props === void 0 ? void 0 : props.modalStatus) != open) {
            props.updateStatus(open);
        }
        if (!open && forceReload) {
            if (props === null || props === void 0 ? void 0 : props.linkreload) {
                window.location.href = props.linkreload;
            }
            else {
                window.location.reload();
            }
        }
    }, [open]);
    useEffect(() => {
        if (open) {
            api
                .getPageJson('login-modal', true)
                .then((data) => {
                var _a, _b, _c, _d;
                const component = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.regions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.filter((el) => el.type_id === 'component_login_modal');
                const customModalData = (_d = component === null || component === void 0 ? void 0 : component.find((el) => {
                    var _a;
                    if (props.customModalId) {
                        return ((_a = el.data) === null || _a === void 0 ? void 0 : _a.customModalId) === props.customModalId;
                    }
                })) === null || _d === void 0 ? void 0 : _d.custom;
                if (customModalData) {
                    setModalData(customModalData);
                }
                else {
                    setModalData(defaultData);
                }
            })
                .catch((err) => {
                setModalData(defaultData);
            });
        }
    }, [open]);
    const values = useMemo(() => {
        return {
            image: modalData === null || modalData === void 0 ? void 0 : modalData.image,
            imageAlt: modalData === null || modalData === void 0 ? void 0 : modalData.imageAlt,
            title: modalData === null || modalData === void 0 ? void 0 : modalData.title,
            subtitle: modalData === null || modalData === void 0 ? void 0 : modalData.subtitle,
            cta: modalData === null || modalData === void 0 ? void 0 : modalData.cta,
            paragraph: modalData === null || modalData === void 0 ? void 0 : modalData.paragraph,
        };
    }, [open, modalData, props.customModalId]);
    if (window.loggedin) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        (props === null || props === void 0 ? void 0 : props.inWishlist) && (React.createElement("div", { className: "row justify-center" },
            React.createElement("div", { className: "col-sm-8 col-md-6 col-lg-4" },
                React.createElement("div", { className: "wishlist-login-box" },
                    React.createElement("h2", { className: "primary-s bold mb-16" }, t('button.signuptoenjoy')),
                    React.createElement("p", { dangerouslySetInnerHTML: { __html: t('wishlist.guestmessage') } }),
                    React.createElement("div", { className: "mt-24" },
                        React.createElement(Button, { type: "button", ariaHaspopup: "dialog", onClick: () => {
                                setOpen(true);
                                analytics.wishlistInteractionLoginRegister();
                            }, cls: ['button--primary'] }, t('login.loginregister'))))))),
        (props === null || props === void 0 ? void 0 : props.incuratorplp) && (React.createElement("div", { className: "info-box-curator" },
            React.createElement("button", { className: "button-underline", "aria-haspopup": "dialog", type: "button", onClick: () => {
                    analytics.curatorsLoginOrRegister();
                    setOpen(true);
                } }, t('checkout.logincta')))),
        (props === null || props === void 0 ? void 0 : props.inlookcard) && (React.createElement("button", { className: "button button--tertiary-inverted locked-button", "aria-haspopup": "dialog", onClick: () => setOpen(true) },
            React.createElement("i", { className: "icon--locked" }),
            React.createElement("p", null, t('button.locked')))),
        (props === null || props === void 0 ? void 0 : props.mbmFinish) && (React.createElement("a", { className: "button button--primary", href: props.linkreload, onClick: (e) => {
                e.preventDefault();
                setOpen(true);
            } },
            React.createElement("span", null, t('button.proceedtopurchase')))),
        (props === null || props === void 0 ? void 0 : props.customLoginBtnLabel) && (React.createElement("button", { className: classNames('button', props.customClass), "aria-haspopup": "dialog", type: "button", onClick: () => {
                var _a;
                (_a = props.customOnClickCB) === null || _a === void 0 ? void 0 : _a.call(props);
                if (props.analyticsKey) {
                    analytics[props.analyticsKey]('login to unlock', 'fragment');
                }
                setOpen(true);
            } }, t(props.customLoginBtnLabel))),
        (props === null || props === void 0 ? void 0 : props.buttonText) && !props.linkText && (React.createElement("button", { className: classNames('button', props.customClass), "aria-haspopup": "dialog", type: "button", onClick: () => {
                setOpen(true);
                analytics.bannerModuleLoginRegistrationPopup(props.titleAnalytics, props.buttonTextAnalytics);
            } }, props === null || props === void 0 ? void 0 : props.buttonText)),
        !(props === null || props === void 0 ? void 0 : props.buttonText) && (props === null || props === void 0 ? void 0 : props.linkText) && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        React.createElement("a", { role: "button", tabIndex: 0, className: classNames('button', props.customClass), "aria-haspopup": "dialog", onKeyDown: (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    setOpen(true);
                    analytics.bannerModuleLoginRegistrationPopup(props.titleAnalytics, props.buttonTextAnalytics);
                }
            }, onClick: (e) => {
                e.preventDefault();
                setOpen(true);
                analytics.bannerModuleLoginRegistrationPopup(props.titleAnalytics, props.buttonTextAnalytics);
            } }, props === null || props === void 0 ? void 0 : props.linkText)),
        React.createElement(ModalDialogWithImage, { image: values.image, alt: values.imageAlt, isOpen: open, className: "login-modal", onRequestClose: () => {
                setOpen(false);
                setOpenRegister(false);
            } },
            React.createElement(React.Fragment, null,
                !forceReload && (React.createElement("div", { className: "login-register-heading" },
                    React.createElement("h2", { className: "mb-8 primary-m" }, values.title),
                    React.createElement("p", { className: "mb-24 primary-xs" }, values.subtitle),
                    React.createElement("span", { className: "border-bottom d-flex mb-24" }))),
                React.createElement(LoginOrRegisterColumn, { privacypolicy: props.privacypolicy, forgotpasswordform: props.forgotpasswordform, defaultRegister: openRegister, setForceReload: setForceReload, closeModal: () => setOpen(false), linkreload: props.reloadPage ? window.location.href : props.linkreload, reloadComponent: props.reloadComponent, from: props.inCart && 'shopping bag', updateLoggeedStatus: props.updateLoggeedStatus, reloadPageRegisteredInStore: props.reloadPageRegisteredInStore, onForgotPassword: props.onForgotPassword, analyticsKey: props.analyticsKey, reloadAfterSocialLogin: props.reloadAfterSocialLogin, pageContext: props.pageContext, editorialData: { customTitle: values === null || values === void 0 ? void 0 : values.paragraph, cta: values.cta } })))));
};
export default LoginModal;
